module.exports = "<!-- {{ versions | json }} -->\n\n<h1>Versions</h1>\n<h2>{{ versions[0]?.name }}</h2>\n\n<app-table\n\t[data]=\"versions\"\n\t[head]=\"head\"\n\t[sort]=\"'updated'\"\n\t[order]=\"-1\"\n></app-table>\n"


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/folder-version/folder-version.component.html
// module id = ../../../../../src/app/folder/folder-version/folder-version.component.html
// module chunks = main